import { Routes } from '@angular/router';
import { AppStoredFileManagerComponent } from '@ukam/admin/stored-files/stored-file-manager.component';
import { AppStoredFileFinderComponent } from '@ukam/admin/stored-file-finder/stored-file-finder.component';
import { AppStoredFileFinderRegisterComponent } from '@ukam/admin/stored-file-finder/register/register.component';

// Features oferecidas por esta aplicação.
export const featureRoutes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('@ukam/laas/laas.routes').then((m) => m.LaasRoutes),
  },
  {
    path: '',
    loadChildren: () =>
      import('@ukam/paas/paas.routes').then((m) => m.PaasRoutes),
  },
  {
    path: '',
    loadChildren: () =>
      import('@ukam/baas/baas.routes').then((m) => m.BaasRoutes),
  },
  {
    path: '',
    loadChildren: () =>
      import('@ukam/compliance/compliance.routes').then((m) => m.ComplianceRoutes),
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('@ukam/admin/admin.routes').then((m) => m.AdminRoutes),
  },
  {
    path: 'apps',
    loadChildren: () =>
      import('@ukam/filters/filters.routes').then((m) => m.AppsRoutes),
  },
  {
    path: 'files',
    component: AppStoredFileManagerComponent,
    data: { title: 'Files' },
  },
  {
    path: 'file-finder',
    component: AppStoredFileFinderComponent,
    data: { title: 'File Finder' },
    children: [{ path: ':id', component: AppStoredFileFinderRegisterComponent, data: { title: 'File' } }],
  }
];
